import React, { useEffect, useState } from "react";
import "./Previeweditmodal.css";
import { ReactComponent as CheckCircleIcon } from "./assets/checkcircleicon.svg";
import { ReactComponent as CloseWhiteICon } from "./assets/closeiconwhite.svg";
import Button from "@mui/material/Button";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useForm, Controller } from "react-hook-form";
import axiosInstance from "./utils/axios";
import Select from "react-select";
import { businessUnitOption } from './utils/constatnts';


export default function PreviewEdit(props: any) {
    const [loading, setLoading] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);
    const [name, setName] = useState("");
    const [errormsg, setErrorMsg] = useState("");
    const rowItem = props.getRowItem;
    const [experience, setExperience] = useState("");
    const [gender, setGender] = useState("");
    const [status, setStatus] = useState("");
    const [referrer_businessunit, SetReferrerBusinessunit] = useState("");
    const [referrering_businessunit, SetReferreringBusinessunit] = useState("");
    const [positionval, setPositionval] = useState("");
    const [selectedOption, setSelectedOption] = useState<any>(null);
    const [isreadonly, setisReadonly] = useState<any>(false);
    const [isstatusreadonly, setisStatusReadonly] = useState<any>(false);
    // const [isrequired, setisRequired] = useState<any>(false);
    const [textareacount, setTextareaCount] = useState<any>();

    const handleOptionChangeposition = (event: any) => {
        const selectedText =
            event.target.options[event.target.selectedIndex].text;
        let candidate_designation;
        switch (selectedText) {
            case "(0-2) years": {
                candidate_designation = "Engineer 1";
                break;
            }
            case "(2-4.5) years": {
                candidate_designation = "Engineer 2";
                break;
            }
            case "(4.6-7.5) years": {
                candidate_designation = "Engineer 3";
                break;
            }
            case "(7.6-12) years": {
                candidate_designation = "Engineer 4";
                break;
            }
            case "(12-15) years": {
                candidate_designation = "Engineer 5/Manager 1";
                break;
            }
            case "(15-18) years": {
                candidate_designation = "Manager 2";
                break;
            }
            case "(18+) years": {
                candidate_designation = "Director 1";
                break;
            }
            case "(22+) years": {
                candidate_designation = "Director 2";
                break;
            }
            default: {
                candidate_designation = "";
                break;
            }
        }
        setPositionval(candidate_designation);
        setValue("position", candidate_designation);
    };
    const handleOptionChangestatus = (event: any) => {
        const selectedText =
            event.target.options[event.target.selectedIndex].text;
        setStatus(selectedText);
    };
    const maxPositionid = 50;
    const positionids = businessUnitOption.flatMap((item) =>
        Array.from({ length: maxPositionid }, (key, index) => ({
            value: `${item}-${(index + 1).toString().padStart(3, "0")}`,
            label: `${item}-${(index + 1).toString().padStart(3, "0")}`,
        }))
    );
    // console.log(positionids);
    const selectSearchStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            boxShadow: "none",
            minHeight: "29px",
            fontSize: "14px",
            // marginTop: "10px",
            borderRadius: "2px",
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            fontSize: "14px",
            ":hover": {
                backgroundColor: "rgb(38, 132, 255)",
                color: "#fff",
            },
        }),
        input: (provided: any, state: any) => ({
            ...provided,
            padding: 0,
            margin: 0,
            fontSize: "14px",
        }),
        dropdownIndicator: (provided: any, state: any) => ({
            ...provided,
            padding: 0,
            color: "rgb(118, 118, 118)",
        }),
        indicatorSeparator: (provided: any, state: any) => ({
            ...provided,
            width: 0,
        }),
        menu: (provided: any, state: any) => ({
            ...provided,
            zIndex: 9999,
            top: "-6px",
        }),
        menuList: (provided: any, state: any) => ({
            ...provided,
            minHeight: "220px",
        }),
        menuPortal: (provided: any, state: any) => ({
            ...provided,
            zIndex: 9999,
        }),
        placeholder: (provided: any, state: any) => ({
            ...provided,
            fontSize: "11px",
        }),
        // Add more styles for other components as needed
    };
    useEffect(() => {
        setName(rowItem?.name ? rowItem.name : "");
        setTextareaCount(rowItem?.skills ? rowItem.skills.length : 0)
        const readOnlycheck =
            props.userRole === "panel"
                ? setisReadonly(true)
                : setisReadonly(false);
        // const requiredcheck = props.userRole === "user" ? setisRequired(true) : setisRequired(false);
        const statusreadonlycheck = (props.email !== rowItem?.modified_by && props.userRole !== "superadmin")  ? 
        setisStatusReadonly(true) : setisStatusReadonly(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowItem]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        clearErrors,
        reset,
        setValue,
        control,
    } = useForm({ shouldUnregister: true });
    const handleClose = () => {
        reset();
        clearErrors();
        setisSuccess(false);
        setErrorMsg("");
        // setDesignation("");
        props.handleCloseDialog(false);
        setTextareaCount(rowItem?.skills ? rowItem.skills.length : 0)
    };

    const onSubmit = (formdata: any) => {
        setErrorMsg("");
        setLoading(true);
        let postUrl;
        let postMethod;
        let postData;
        if (rowItem === undefined) {
            formdata.status = "New";
            formdata.position = positionval;
            formdata.created_by = props.email;
            formdata.modified_by = props.email;
            let formDataObj = new FormData();
            formDataObj.append("formData", JSON.stringify(formdata));
            if (props.isFile) {
                formDataObj.append("file", props.isFile);
            }
            postUrl = "/candidatelist/add";
            postMethod = "POST";
            postData = formDataObj;
        } else {
            formdata.modified_by = props.email;
            let formDataObj = new FormData();
            formDataObj.append("formData", JSON.stringify(formdata));
            formdata.id = rowItem.id;
            postUrl = `/candidatelist/update/${rowItem.id}`;
            postMethod = "PUT";
            postData = formDataObj;
        }

        axiosInstance(postUrl, {
            method: postMethod,
            data: postData,
            headers: {
                // 'Authorization': `bearer ${token}`,
                // 'Content-Type': 'application/json'
                "Content-Type": "multipart/form-data",
            },
        })
            .then((response: any) => {
                setLoading(false);
                if (response && response.data) {
                    if (response.data.success) {
                        setisSuccess(true);
                        setErrorMsg("");
                    } else {
                        setErrorMsg(response.data.message);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                setErrorMsg("System error occurred.Please try again later.");
            });
    };

    return (
      <div className="dialog-section" style={{ position: "relative" }}>
        <Dialog
          open={props.isEditDialogOpened}
          onClose={handleClose}
          fullWidth
          maxWidth="sm"
        >
          {!isSuccess ? (
            <div>
              <DialogTitle style={{background:"#227AD2", color:"#fff", padding:"12px 24px"}}>Preview & Edit Candidate</DialogTitle>
              <CloseWhiteICon
                style={{
                  position: "absolute",
                  right: 18,
                  top: 12,
                  color: "#393939",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleClose();
                }}
              />
              {errormsg && <div className="err-msg-section" style={{marginTop:"10px"}}>{errormsg}</div>}
              <DialogContent style={{padding:0}}>
                <form className="form-section">
                {/* <div className="form-divider"></div> */}
                 <div className="form-divide-section">
                  <div className="form-title"> Candidate Information: </div>
                    <div className="form-row">
                      <div className="label-section">
                        <label>
                          Candidate Name(Full name)
                          <span style={{ color: "#d32f2f" }}>*</span>
                        </label>
                      </div>
                      <div>
                        <input
                          readOnly={rowItem?.name && isreadonly}
                          className={
                            errors.name ? "input-section error" : "input-section"
                          }
                          {...register("name", {
                            required: true,
                            onBlur: (e: any) => {
                              setName(e.target.value);
                            },
                          })}
                          defaultValue={rowItem?.name ? rowItem.name : ""}
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="row-column" style={{ marginRight: "10px" }}>
                        <div className="label-section">
                          <label>
                            Canditate Email{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </label>
                        </div>
                        <div>
                          <input
                            readOnly={rowItem?.email && isreadonly}
                            placeholder="Enter valid Email..."
                            className={
                              errors.email
                                ? "input-section error"
                                : "input-section"
                            }
                            {...register("email", {
                              required: true,
                              pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address",
                              },
                            })}
                            defaultValue={
                              props.read_emails
                                ? props.read_emails
                                : rowItem?.email
                            }
                          />
                        </div>
                      </div>
                      <div className="row-column">
                        <div className="label-section">
                          <label>
                            Candidate Phone{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </label>
                        </div>
                        <div>
                          <input
                            readOnly={rowItem?.phone && isreadonly}
                            placeholder="Enter Valid Phone..."
                            className={
                              errors.phone
                                ? "input-section error"
                                : "input-section"
                            }
                            {...register("phone", {
                              required: true,
                              pattern: {
                                value:
                                  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                message: "Invalid Phone Number",
                              },
                            })}
                            defaultValue={
                              props.read_mobileNumber
                                ? props.read_mobileNumber
                                : rowItem?.phone
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="label-section">
                        <label>
                          Skills <span style={{ color: "#d32f2f" }}>*</span>
                        </label>
                      </div>
                      <div>
                        <fieldset
                          style={{ padding: 0, border: 0 }}
                          disabled={rowItem?.skills && isreadonly}
                        >
                          <textarea maxLength={255}
                            className={
                              errors.skills
                                ? "input-section error"
                                : "input-section"
                            }
                            {...register("skills", {
                              required: true,
                            })}
                            defaultValue={rowItem?.skills ? rowItem.skills : ""}
                            onChange={e => setTextareaCount(e.target.value.length)}
                            placeholder="Enter Skills (Only 0 to 255 characters)."
                          />
                          <div className="textcount-section">
                            Characters remaining: {textareacount}/255
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="row-column">
                        <div className="label-section">
                          <label>
                            Gender <span style={{ color: "#d32f2f" }}>*</span>
                          </label>
                        </div>
                        <div>
                          <fieldset
                            style={{
                              padding: 0,
                              border: 0,
                            }}
                            disabled={rowItem?.gender && isreadonly}
                          >
                            <select
                              className={
                                errors.gender
                                  ? "select-section error"
                                  : "select-section"
                              }
                              {...register("gender", {
                                required: true,
                              })}
                              onChange={(event) => setGender(event.target.value)}
                              defaultValue={rowItem?.gender ? rowItem.gender : ""}
                            >
                              <option value="">Select</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                              <option value="others">Others</option>
                            </select>
                          </fieldset>
                        </div>
                      </div>
                      <div className="row-column" style={{ marginLeft: "12px" }}>
                        <div className="label-section">
                          <label>
                            Experience in years{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </label>
                        </div>
                        <div>
                          <fieldset
                            style={{
                              padding: 0,
                              border: 0,
                            }}
                            disabled={rowItem?.gender && isreadonly}
                          >
                            <select
                              className={
                                errors.experience
                                  ? "select-section error"
                                  : "select-section"
                              }
                              {...register("experience", {
                                required: true,
                              })}
                              onChange={(event: any) => {
                                handleOptionChangeposition(event);
                                setExperience(event.target.value);
                              }}
                              defaultValue={
                                rowItem?.experience ? rowItem.experience : ""
                              }
                            >
                              <option value="">Select</option>
                              <option value="0-2">(0-2) years</option>
                              <option value="2-4.5">(2-4.5) years</option>
                              <option value="4.6-7.5">(4.6-7.5) years</option>
                              <option value="7.6-12">(7.6-12) years</option>
                              <option value="12-14">(12-15) years</option>
                              <option value="14-16">(15-18) years</option>
                              <option value="16-21">(18+) years</option>
                              <option value="21above">(22+) years</option>
                            </select>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="row-column" style={{ marginRight: "14px" }}>
                          <div className="label-section" style={{marginBottom:"10px"}}>
                            <label style={{position:"relative", top:"4px"}}>
                              Position Id/Job Id{" "}
                              {props.userRole === "user" ?
                                <span style={{ color: "#d32f2f" }}>*</span>
                                : ""
                              }
                            </label>
                          </div>
                          <div className="search-select">
                            <fieldset
                              style={{
                                padding: 0,
                                border: 0,
                              }}
                              disabled={rowItem?.referrer_positionid && isreadonly}
                            >
                              <Controller
                                control={control}
                                name="referrer_positionid"
                                defaultValue={
                                  rowItem?.referrer_positionid
                                    ? rowItem.referrer_positionid
                                    : ""
                                }
                                render={({
                                  field: { onChange, value, name, ref },
                                }) => {
                                  const currentSelection = positionids.find(
                                    (c) => c.value === value
                                  );

                                  const handleSelectChange = (
                                    selectedOption: any
                                  ) => {
                                    onChange(selectedOption?.value);
                                  };

                                  return (
                                    <Select
                                      value={currentSelection}
                                      name={name}
                                      options={positionids}
                                      onChange={handleSelectChange}
                                      styles={selectSearchStyles}
                                      menuPosition="fixed"
                                      placeholder="Search or Select Position..."
                                      className={
                                        errors.referrer_positionid
                                          ? "positionid-error"
                                          : ""
                                      }
                                    />
                                  );
                                }}
                                rules={{ required: (props.userRole === "user" ? true: false) }}
                              />
                            </fieldset>
                          </div>
                      </div>
                      <div className="row-column">
                            <div className="label-section">
                              <label>
                                  Referring Business Unit
                                <span style={{ color: "#d32f2f" }}>*</span>
                              </label>
                            </div>
                            <div>
                              <fieldset
                                style={{
                                  padding: 0,
                                  border: 0,
                                }}
                                disabled={
                                  rowItem?.referrering_businessunit && isreadonly
                                }
                              >
                                <select
                                  className={
                                    errors.referrering_businessunit
                                      ? "select-section error"
                                      : "select-section"
                                  }
                                  {...register("referrering_businessunit", {
                                    required: true,
                                  })}
                                  onChange={(event) =>
                                    SetReferreringBusinessunit(event.target.value)
                                  }
                                  // value={businesunit}
                                  defaultValue={
                                    rowItem?.referrering_businessunit
                                      ? rowItem.referrering_businessunit
                                      : ""
                                  }
                                >
                                  <option value="">Select</option>
                                  {businessUnitOption.map((item, i) => (
                                    <option key={i}>{item}</option>
                                  ))}
                                </select>
                              </fieldset>
                            </div>
                      </div>
                    </div>
                    <div className="form-row">
                    { props.userRole !== "user" && 
                      <div className="row-column" style={{ marginRight: "12px" }}>
                        <div className="label-section">
                          <label>
                            Position
                            {/* <span style={{ color: "#d32f2f" }}>*</span> */}
                          </label>
                        </div>
                        <div>
                          <input
                            readOnly
                            className="input-section"
                            {...register("position")}
                            defaultValue={
                              rowItem?.position ? rowItem.position : ""
                            }
                          />
                        </div>
                      </div>
                      }
                       { props.userRole !== "user" && 
                        <div className="row-column">
                          <div className="label-section">
                              <label>Location</label>
                            </div>
                            <div>
                              <input
                                className="input-section"
                                {...register("location")}
                                defaultValue={
                                  rowItem?.location ? rowItem.location : ""
                                }
                              />
                            </div>
                          </div>
                      }
                    </div>
                    { props.userRole !== "user" && 
                      <div className="form-row" style={{marginTop:"1em"}}>
                        <div
                          className="row-three-column"
                          style={{ marginRight: "14px" }}
                        >
                          <div className="label-section">
                            <label>
                              Current CTC{" "}
                              <span
                                style={{
                                  color: "#919191",
                                  fontSize: "12px",
                                }}
                              >
                                (per annum)
                              </span>
                            </label>
                          </div>
                          <div>
                            <input
                              className="input-section"
                              {...register("current_ctc")}
                              defaultValue={
                                rowItem?.current_ctc ? rowItem.current_ctc : ""
                              }
                            />
                          </div>
                        </div>
                        <div
                          className="row-three-column"
                          style={{ marginRight: "14px" }}
                        >
                          <div className="label-section">
                            <label>Expected CTC
                              <span
                                  style={{
                                    color: "#919191",
                                    fontSize: "12px",
                                  }}
                                >(per annum)
                              </span>
                            </label>
                          </div>
                          <div>
                            <input
                              className="input-section"
                              {...register("expected_ctc")}
                              defaultValue={
                                rowItem?.expected_ctc
                                  ? rowItem.expected_ctc
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <div className="row-three-column">
                          <div className="label-section">
                              <label>
                                Notice Period
                                <span
                                  style={{
                                    color: "#919191",
                                    fontSize: "12px",
                                  }}
                                >(in days)
                              </span>
                              </label>
                            </div>
                            <div>
                              <input
                                className={
                                  errors.email
                                    ? "input-section error"
                                    : "input-section"
                                }
                                {...register("notice_period", { })}
                                defaultValue={
                                  props.notice_period
                                    ? props.notice_period
                                    : rowItem?.notice_period
                                }
                              />
                            </div>
                        </div>
                      </div>
                    }
                  </div> 
                  <div className="form-divider"></div>
                  <div className="form-divide-section">
                    <div className="form-title"> Employee Information: </div>
                    <div className="form-row">
                      <div className="row-column" style={{ marginRight: "14px" }}>
                        <div className="label-section">
                          <label>
                            Employee Name{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </label>
                        </div>
                        <div>
                          <input
                            readOnly
                            className={
                              errors.referrer_name
                                ? "input-section error"
                                : "input-section"
                            }
                            {...register("referrer_name", {
                              required: true,
                            })}
                            defaultValue={
                              rowItem?.referrer_name
                                ? rowItem.referrer_name
                                : props.referrer_name
                            }
                          />
                        </div>
                      </div>
                      <div className="row-column">
                        <div className="label-section">
                          <label>
                            Employee Email{" "}
                            <span style={{ color: "#d32f2f" }}>*</span>
                          </label>
                        </div>
                        <div>
                          <input
                            readOnly
                            className={
                              errors.referrer_email
                                ? "input-section error"
                                : "input-section"
                            }
                            {...register("referrer_email", {
                              required: true,
                            })}
                            defaultValue={
                              rowItem?.referrer_email
                                ? rowItem.referrer_email
                                : props.email
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="form-row">
                        <div className="row-column" style={{ marginRight: "14px" }}>
                          <div className="label-section">
                            <label>
                              Employee Business Unit
                              <span style={{ color: "#d32f2f" }}>*</span>
                            </label>
                          </div>
                          <div>
                            <fieldset
                              style={{
                                padding: 0,
                                border: 0,
                              }}
                              disabled={
                                rowItem?.referrer_businessunit && isreadonly
                              }
                            >
                              <select
                                className={
                                  errors.referrer_businessunit
                                    ? "select-section error"
                                    : "select-section"
                                }
                                {...register("referrer_businessunit", {
                                  required: true,
                                })}
                                onChange={(event) =>
                                  SetReferrerBusinessunit(event.target.value)
                                }
                                // value={businesunit}
                                defaultValue={
                                  rowItem?.referrer_businessunit
                                    ? rowItem.referrer_businessunit
                                    : ""
                                }
                              >
                                <option value="">Select</option>
                                {businessUnitOption.map((item, i) => (
                                  <option key={i}>{item}</option>
                                ))}
                              </select>
                            </fieldset>
                          </div>
                        </div>
                        {props.userRole !== "user" && 
                        <div className="row-column">
                          <div className="label-section">
                            <label>
                              Status
                              {/* <span style={{ color: "#d32f2f" }}>*</span> */}
                            </label>
                          </div>
                          <div>
                            <select disabled = {
                              (
                                rowItem?.status === "Interviews are in Progress" || 
                                rowItem?.status === "Shared for Hiring Manager Review" ||
                                rowItem?.status === "Candidate on hold" ||
                                rowItem?.status === "Offered" ||
                                rowItem?.status === "Joined"
                              ) && (isstatusreadonly)}
                              className={
                                errors.status
                                  ? "select-section error"
                                  : "select-section"
                              }
                              {...register("status")}
                              onChange={handleOptionChangestatus}
                              // value={status}
                              defaultValue={
                                rowItem?.status ? rowItem.status : ""
                              }
                            >
                              <option>New</option>
                              <option>Shared for Hiring Manager Review</option>
                              <option>Profile Reject</option>
                              <option>Interviews are in Progress</option>
                              <option>Technical Reject</option>
                              <option>Manager Reject</option>
                              <option>HR Reject</option>
                              <option>Position on hold</option>
                              <option>Candidate on hold</option>
                              <option>Position Filled</option>
                              <option>Final Select</option>
                              <option>Offered</option>
                              <option>Joined</option>
                              <option>Offer Declined</option>
                              <option>Resume saved in the Database</option>
                              {/* <option>Select</option>
                              <option>New</option>
                              <option>Resume Shortlisted for Interview</option>
                              <option>Resume Reject</option>
                              <option>Moved to Other BU</option>
                              {props.userRole !== "panel" && (
                                <>
                                  <option>HR Reject</option>
                                  <option>Technical Reject</option>
                                  <option>Offered</option>
                                  <option>Joined</option>
                                  <option>Offer Declined</option>
                                </>
                              )} */}
                            </select>
                          </div>
                        </div>
                        }   
                      </div>
                      {props.userRole !== "user" && 
                      <div className="form-row">
                        <div className="label-section">
                          <label>
                            Remarks
                            {/* <span style={{ color: "#d32f2f" }}>*</span> */}
                          </label>
                        </div>
                        <div>
                          <textarea
                            className={
                              errors.recruiter_remarks
                                ? "input-section error"
                                : "input-section"
                            }
                            {...register("recruiter_remarks")}
                            defaultValue={
                              rowItem?.recruiter_remarks
                                ? rowItem.recruiter_remarks
                                : ""
                            }
                          />
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                  { props.userRole === "user" &&  
                    <div className="form-divider" style={{marginBottom:"1.5em"}}></div>
                  }
                </form>
              </DialogContent>
              <div className="modalbtn-section">
                <Button
                  variant="outlined"
                  sx={{
                    textTransform: "capitalize",
                    color: "#227AD2",
                    borderColor: "#227AD2",
                    width: "140px",
                    marginRight: "12px",
                  }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    textTransform: "capitalize",
                    color: "#fff",
                    background: "#227AD2",
                    width: "140px",
                  }}
                  onClick={handleSubmit(onSubmit)}
                >
                  Submit
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <DialogContent>
                <div className="modalsuccess-section">
                  <div className="successicon-section">
                    <CheckCircleIcon />
                  </div>
                  <div className="successcontent-section">
                    The Referer Candidate <strong>"{name}"</strong> was added
                    successfully.
                  </div>
                  <div className="successclose-section">
                    <Button
                      variant="outlined"
                      sx={{
                        textTransform: "capitalize",
                        color: "#227AD2",
                        borderColor: "#227AD2",
                        padding: "5px 28px",
                      }}
                      onClick={() => {
                        handleClose();
                        props.getCandidateList();
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </DialogContent>
            </div>
          )}
          {loading ? (
            <div className="load-spinner">
              <CircularProgress size="4rem" sx={{ color: "#fff" }} />
              <div className="spinner-text">Loading Please Wait....</div>
            </div>
          ) : (
            ""
          )}
        </Dialog>
      </div>
    );
}
